export const markDownStylesCss = `
        .blog-post h2 {
          font-size: 2rem;
          font-weight: bold;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
        }
        .blog-post h3 {
          font-size: 1.5rem;
          font-weight: bold;
          margin-top: 1rem;
          margin-bottom: 0.5rem;
        }
        .blog-post p {
          margin-bottom: 1.5rem;
        }
        .blog-post .hero {
          width: 100%;
        }
        .blog-post .back {
          width: 100%;
          max-width: 1200px;
          color: #2d3748;
        }
        .blog-post img {
          border-radius: 0.33em;
          margin-bottom: 1em;
        }
        .blog-post pre,
        .blog-post code {
          font-size: 11pt;
          background: #333;
          color: #fff;
          padding: 0.1em;
          padding-left: 0.5em;
          padding-right: 0.5em;
          border-radius: 0.25em;
          display: inline-block;
          margin-top: 0.25em;
          margin-bottom: 0.25em;
        }
        .blog-post ul {
          list-style-type: disc;
          margin-bottom: 1em;
          margin-left: 1.5em;
        }
        .blog-post a {
          color: #13aae3;
        }
        .blog-post a h2 {
          color: #2d3748;
        }
        .blog-post a:hover {
          color: #50bae3;
        }
      `;
